export default __webpack_public_path__ + "static/media/pantalon-rockero-hombre.5250252e.png";